import { useOne } from '@refinedev/core';

import {
  CropwiseAiMessageModel,
  CropwiseAiSectionModel,
} from '../cropwise-ai.model';

export const useCropwiseAiConversation = (sessionId: string | null) => {
  const { data, isFetching } = useOne<CropwiseAiSectionModel>({
    resource: 'balance-ai/conversations',
    id: sessionId ?? undefined,
  });

  const historicalMessages: CropwiseAiMessageModel[] =
    sessionId && data?.data.sessionId === sessionId
      ? data.data.messages ?? []
      : [];

  return {
    isFetching,
    historicalMessages,
  };
};
